<template>
  <v-card>
    <v-card-title class="grey lighten-5 headline">
      Cadastro de Observações
    </v-card-title>
    <v-row class="pa-4" justify="space-between">
      <v-col cols="12">
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model.trim="blacklist.nome"
                  label="Nome"
                  clearable
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col cols="12">
                <v-text-field
                  v-model.trim="blacklist.valorIdentificacao"
                  label="CPF / CNPJ"
                  clearable
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model.trim="blacklist.motivo"
                  label="Motivo"
                  clearable
                  :rules="[rules.required]"
                  required
                ></v-textarea>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col v-if="pesquisandoImagens === false">
                <h5>Anexos</h5>
                <v-row>
                  <v-col
                    cols="6"
                    v-for="(arq, indexArq) in documento.arquivos"
                    :key="arq.idFront"
                  >
                    <input
                      type="file"
                      accept=".png, .jpeg, .bmp, .webp, .pdf"
                      class="mb-2"
                      required
                      @change="setFiles"
                      :data-indexarq="indexArq"
                    />
                    <v-btn
                      v-if="indexArq > 0"
                      color="error"
                      icon
                      @click="excluirArquivo(indexArq)"
                      class="ml-5"
                      ><v-icon small>fas fa-trash</v-icon></v-btn
                    >
                  </v-col>
                  <v-col cols="12" text-center>
                    <v-btn color="primary" fab x-small dark @click="novoArquivo"
                      ><v-icon>mdi-plus</v-icon></v-btn
                    >
                  </v-col>
                </v-row>

                <p v-for="(anexo, index) in anexos" :key="anexo.id">
                  <v-divider></v-divider>
                  <v-btn
                    @click="
                      anexo.extensao.toLowerCase() === 'pdf'
                        ? exibirPDF(anexo)
                        : exibirImagem(anexo)
                    "
                    color="primary"
                  >
                    <v-icon class="mr-2">fas fa-file</v-icon>
                    {{
                      anexo.nomeArquivoOriginal
                        ? anexo.nomeArquivoOriginal
                        : "Anexo " + (index + 1)
                    }}
                  </v-btn>
                  <v-btn
                    color="error"
                    icon
                    @click="excluirAnexo(anexo)"
                    class="ml-5"
                    ><v-icon small>fas fa-trash</v-icon></v-btn
                  >
                </p>
              </v-col>
              <v-col v-else> Carregando anexos... </v-col>
            </v-row>
            <v-divider></v-divider>
            <p>
              <v-btn @click="voltar" color="error" large>Voltar</v-btn>
              <v-btn
                @click="salvar"
                color="primary"
                large
                class="ml-2"
                :disabled="saving || block"
                >Salvar</v-btn
              >
            </p>
          </v-container>
          <div v-if="motivos.length > 0">
            <v-card-title class="grey lighten-5 headline">
              Histórico de Alterações
            </v-card-title>
            <v-data-table :headers="headers" :items="motivos">
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.blacklistID }}</td>
                  <td>{{ formatarData(item.dataCadastro) }}</td>
                  <td>{{ item.motivo }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-form>
      </v-col>

      <v-divider vertical></v-divider>
    </v-row>
    <v-dialog
      v-model="dialogPDF"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      width="unset"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="fecharPDF()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="downloadFile(pdfExibir)"> Salvar </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-row class="mt-2" justify="center">
          <vue-pdf-embed
            v-if="dialogPDF"
            :source="pdfExibir.caminhoVisualizacao"
            style="
              height: 100%;
              flex: 1;
              margin-left: 15%;
              margin-right: 15%;
              margin-top: 2%;
              margin-bottom: 2%;
            "
          />
        </v-row>
      </v-card>
    </v-dialog>
    <TelaLoading :overlay="saving"></TelaLoading>
  </v-card>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import { SET_LOADING } from "@/store/config.module";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import moment from "moment";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import axios from "axios";

export default {
  name: "blacklistCadastro",
  data() {
    return {
      headers: [
        { text: "ID Observação", value: "blacklistID" },
        { text: "Data Alteração", value: "dataCadastro" },
        { text: "Motivo", value: "motivo" },
      ],
      valid: false,
      saving: false,
      selectionType: "independent",
      cliente: {},
      block: false,
      blacklist: {
        id: 0,
        clienteID: 0,
        nome: "",
        valorIdentificacao: "",
        motivo: "",
      },
      motivos: [],
      departamentos: [],
      open: ["public"],
      dialog: false,
      dialogImagem: false,
      dialogHistorico: false,
      dialogPDF: false,
      pdfExibir: {},
      pesquisandoImagens: false,
      file: null,
      urlCaminhoExibir: null,
      anexos: [],
      documento: {
        id: 0,
        status: 0,
        propriedadesEntidade: [],
        nome: "",
        periodo: "",
        grupo: "",
        departamento: "",
        departamentoID: 0,
        empresa: "",
        validadeString: null,
        arquivos: [{ idFront: new Date().getTime(), nome: "", arquivo: {} }],
        tipoDocumento: 0,
        entidade: 0,
        grupoID: 0,
        indice: 0,
      },
      rules: {
        required: (v) => !!v || "Obrigatório",
      },
    };
  },
  components: {
    TelaLoading,
    VuePdfEmbed,
  },
  methods: {
    removerMascara() {
      this.blacklist.valorIdentificacao = this.blacklist.valorIdentificacao
        .match(/\d/g)
        .join("");
    },
    formatarData(data) {
      let newDate = moment(data);
      return newDate.format("DD/MM/yyyy HH:mm");
    },

    adicionarMascara(item) {
      let mascara = "";
      switch (item) {
        case 1:
          mascara = "###.###.###-##";
          break;
        case 2:
          mascara = "##.###.###/####-##";
          break;
        default:
          mascara = "";
          break;
      }

      return mascara;
    },
    async validarPropriedade(propriedadeValor, propriedadeInteligenteID) {
      try {
        this.saving = true;
        const { data: result } = await ApiService.query(
          `entidade/validar/propriedade/${propriedadeValor
            .match(/\d/g)
            .join(
              ""
            )}/propriedadeInteligenteID/${propriedadeInteligenteID}/cliente/${
            this.cliente.id
          }`
        );
        if (!result.success) {
          SweetAlert.sweetAlertError(result.errors);
          this.block = true;
        } else this.block = false;
        this.saving = false;
      } catch (ex) {
        this.saving = false;
      }
    },

    async downloadFile(arquivo) {
      const result = await axios.get(arquivo.caminhoVisualizacao, {
        responseType: "blob",
      });
      const blob = new Blob([result.data]);
      const a = document.createElement("a");
      a.download =
        arquivo.nomeArquivoOriginal ??
        arquivo.nomeBlob.split("/")[arquivo.nomeBlob.split("/").length - 1];
      a.href = URL.createObjectURL(blob);
      a.click();
      URL.revokeObjectURL(a.href);
    },

    exibirImagem(arquivo) {
      if (!arquivo) {
        this.dialogImagem = false;
        return;
      }

      this.urlCaminhoExibir = arquivo.caminhoVisualizacao;
      this.dialogImagem = true;
      this.downloadFile(arquivo);
    },

    exibirPDF(pdf) {
      if (!pdf) {
        this.dialogPDF = false;
        return;
      }

      this.pdfExibir = pdf;
      this.dialogPDF = true;
    },

    fecharPDF() {
      this.pdfExibir = {};
      this.dialogPDF = false;
    },

    excluirArquivo(index) {
      this.documento.arquivos.splice(index, 1);
    },

    excluirAnexo(anexo) {
      this.saving = true;
      return new Promise((resolve) => {
        ApiService.post("arquivo/RemoverAnexoBlacklist/" + anexo.id).then(
          ({ data }) => {
            resolve(data);
            this.saving = true;
            if (data.success) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Anexo Removido!",
                showConfirmButton: false,
                timer: 1500,
              }).then(function () {
                history.go(0);
              });
            } else SweetAlert.sweetAlertError(data.errors);
          }
        );
      }).finally(() => (this.saving = false));
    },

    setFiles(event) {
      if (!this.verificar(event.target.value)) {
        Swal.fire({
          position: "center",
          title: "Tipo de arquivo não permitido",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
        this.excluirArquivo(event.target.dataset.indexarq);
        this.documento.arquivos.push({
          idFront: new Date().getTime(),
          nome: "",
          arquivo: {},
        });
      } else {
        this.documento.arquivos[event.target.dataset.indexarq].arquivo =
          event.target.files;
      }
    },

    novoArquivo() {
      this.documento.arquivos.push({
        idFront: new Date().getTime(),
        nome: "",
        arquivo: {},
      });
    },

    carregarImagens() {
      this.pesquisandoImagens = true;
      this.anexos = [];

      return new Promise((resolve) => {
        ApiService.get(
          "registroimagem/getAnexoBlacklistById/" + this.blacklist.id
        ).then(({ data }) => {
          if (data.success) {
            resolve(data);

            this.anexos = data.data;
          } else {
            SweetAlert.sweetAlertError(data.errors);
          }

          this.pesquisandoImagens = false;
        });
      });
    },

    verificar(value) {
      value = value.toLowerCase();

      return (
        value.includes(".pdf") ||
        value.includes(".psd") ||
        value.includes(".tiff") ||
        value.includes(".png") ||
        value.includes(".jpeg") ||
        value.includes(".jpg") ||
        value.includes(".bmp") ||
        value.includes(".webp")
      );
    },

    salvar() {
      let formData = new FormData();
      for (let i = 0; i < this.documento.arquivos.length; i++) {
        const arq = this.documento.arquivos[i];
        formData.append("arquivos", arq.arquivo[0]);
      }

      let self = this;
      this.removerMascara();
      if (this.$refs.form.validate()) {
        this.saving = true;
        if (this.blacklist.id === 0) {
          return new Promise((resolve) => {
            ApiService.post("blacklist", this.blacklist).then(({ data }) => {
              resolve(data);

              if (data.success) {
                ApiService.postFormData(
                  "arquivo/uploadAnexoBlacklist/" + data.data.id,
                  formData
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Observação Cadastrada com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.$router.push({ name: "blacklist" });
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          }).finally(() => (this.saving = false));
        } else {
          ApiService.postFormData(
            "arquivo/uploadAnexoBlacklist/" + this.blacklist.id,
            formData
          );

          return new Promise((resolve) => {
            ApiService.put(
              "blacklist/" + this.blacklist.id,
              this.blacklist
            ).then(({ data }) => {
              resolve(data);

              if (data.success) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Observação Alterada com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.$router.push({ name: "blacklist" });
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          }).finally(() => (this.saving = false));
        }
      }
    },

    async buscarBlacklist(id) {
      const { data: result } = await ApiService.get("blacklist/" + id);
      if (result.success) {
        this.blacklist = result.data;
        this.$store.commit(SET_LOADING, false);
      } else SweetAlert.sweetAlertError(result.errors);
    },

    async buscarMotivoHistorico(id) {
      const { data: result } = await ApiService.get(
        "blacklistMotivoHistorico/HistoricoMotivo/" + id
      );
      if (result.success) {
        this.motivos = result.data;
        this.$store.commit(SET_LOADING, false);
      } else SweetAlert.sweetAlertError(result.errors);
    },

    voltar() {
      history.go(-1);
    },
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Blacklists" }]);
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.blacklist.clienteID = this.cliente.id;
    if (this.$route.params.id !== undefined) {
      await this.buscarBlacklist(this.$route.params.id);
      await this.buscarMotivoHistorico(this.$route.params.id);
      this.carregarImagens();
    } else this.$store.commit(SET_LOADING, false);
  },
  created() {
    let permissao = Permissoes.Incluir;

    if (this.$route.params.id !== undefined) permissao = Permissoes.Editar;

    if (!PermissoesService.verificarAcesso(Modulo.Blacklist, permissao)) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
